import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ num, label, light = false }) => (
  <Reveal>
    <div className="flex items-center gap-4" data-testid={`chapter-${num}`}>
      <span
        className={`text-xs font-semibold uppercase tracking-[0.28em] ${
          light ? "text-[#9DBFA9]" : "text-guinep-mid"
        }`}
      >
        {num} / {label}
      </span>
      <span className={`h-px flex-1 max-w-24 ${light ? "bg-white/20" : "bg-guinep-line"}`} />
    </div>
  </Reveal>
);
